import { createSlice } from "@reduxjs/toolkit";
import { location } from "../../../types/calendar";

const initialState = {
  date: new Date(),
  selectedTeamMember: null as number | null,
  view: "week" as "week" | "month" | "day",
  locationId: null as number | null,
  activeLocation: null as location | null,
};
const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    setDate: (state, action: { payload: Date }) => {
      state.date = new Date(action.payload);
    },
    setView: (state, action: { payload: "week" | "month" | "day" }) => {
      state.view = action.payload;
    },
    setSelectedTeamMember: (state, action: { payload: number | null }) => {
      state.selectedTeamMember = action.payload;
    },
    setLocationId: (state, action: { payload: number | null }) => {
      state.locationId = action.payload;
    },
    setActiveLocation: (state, action: { payload: location | null }) => {
      state.activeLocation = action.payload;
    },
  },
});

export const {
  setDate,
  setView,
  setSelectedTeamMember,
  setLocationId,
  setActiveLocation,
} = calendarSlice.actions;
export default calendarSlice.reducer;
